import { BellElectric, ChevronLeft, ChevronRight, ImagePlay, ListChecks, Plus } from "lucide-react";
import CourseContentCard from "./CourseContentCard";

import contentMan from "./img/contentMan.svg";
import { useRef, useState } from "react";
const CourseContentCardHolder=({coursePageObject})=>{

     
 const HorizontalScroller = ({coursePageObject, items }) => {
    const scrollerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
  
    const scroll = (direction) => {
      if (scrollerRef.current) {
        const scrollAmount = 260; // Adjust scroll distance per click
        scrollerRef.current.scrollBy({
          left: direction === "left" ? -scrollAmount : scrollAmount,
          behavior: "smooth",
        });
      }
    };
     // Mouse drag handlers
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollerRef.current.offsetLeft);
    setScrollLeft(scrollerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent text selection
    const x = e.pageX - scrollerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust for sensitivity
    scrollerRef.current.scrollLeft = scrollLeft - walk;
  };


  const handleMouseUp = () => setIsDragging(false);
  const handleMouseLeave = () => setIsDragging(false);

    return (
      <div className="scroller-wrapperCoursePage" style={{background:`${coursePageObject?.milestoneCarousel?.bgColor?.color}`,
    border:` ${coursePageObject?.milestoneCarousel?.border?.borderWidth?.value+coursePageObject?.milestoneCarousel?.border?.borderWidth?.resolution} ${coursePageObject?.milestoneCarousel?.border?.borderType}  ${coursePageObject?.milestoneCarousel?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.topLeft?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.topRight?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.bottomLeft?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.bottomRight?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.bottomRight?.resolution}`,
}}>
        <button className="scroll-btnCoursePage left" style={{background:coursePageObject?.milestoneCarousel?.iconBgColor?.color}} onClick={() => scroll("left")}>
          <ChevronLeft   strokeWidth={2} absoluteStrokeWidth  size={30} 
                   color={coursePageObject?.milestoneCarousel?.iconColor?.color} />
        </button> 
        <div className="scrollerCoursePage" ref={scrollerRef} >
          {items.map((item, index) => (
            <div key={index} style={{display:"flex",justifyContent:"flex-start", }} onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}   >
       
            <div
className={"posRelative"  }
             style={{ margin:"0px",marginTop:"1px",background:item?.active?coursePageObject?.milestoneCarousel?.bgColor?.color:"rgba(255, 255, 255, 1) ",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden",maxWidth:"200px",fontSize:"22px",padding:"10px",}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div   style={{width:"155px",marginTop:"0px",fontWeight:"999",}}  >
                   <div  className="TitleWithEllipsis coursePageTagsFont" style={{width:"150px",fontWeight:"999",display:"flex",justifyContent:"center",alignItems:"center",
                    color:coursePageObject?.milestoneCarousel?.textColor?.color
                   }}  >
                  MileStone {item?.menuOrder}  
                   </div> 
                   {/* <div align="center" className="" style={{marginTop:"20px",marginLeft:"30px"}} ><div  
                    style={{cursor:"pointer",color:"rgba(144, 202, 249,1)",left:"50px",background:"#fff",width:"120px",fontSize:"14px",height:"40px"}} 
            className="milestoneButtonInCard" >Add Content </div>
           </div> */}
                     </div>
                   
                   </div>     
                   </div>  
            </div>
          ))}


      
          
                   
        </div>
        <button className="scroll-btnCoursePage right" style={{background:coursePageObject?.milestoneCarousel?.iconBgColor?.color}} onClick={() => scroll("right")}>
        <ChevronRight   strokeWidth={2} absoluteStrokeWidth  size={30} 
                   color={coursePageObject?.milestoneCarousel?.iconColor?.color}/>
        </button>
      </div>
    );
  };

    return(<>
    <div className="themeCoursePage"  style={{marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",position:"relative",background:`${coursePageObject?.contentOuter?.bgColor?.color}`,
    border:` ${coursePageObject?.contentOuter?.border?.borderWidth?.value+coursePageObject?.contentOuter?.border?.borderWidth?.resolution} ${coursePageObject?.contentOuter?.border?.borderType}  ${coursePageObject?.contentOuter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.contentOuter?.borderRadius?.topLeft?.value}${coursePageObject?.contentOuter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.contentOuter?.borderRadius?.topRight?.value}${coursePageObject?.contentOuter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.contentOuter?.borderRadius?.bottomLeft?.value}${coursePageObject?.contentOuter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.contentOuter?.borderRadius?.bottomRight?.value}${coursePageObject?.contentOuter?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}>
{coursePageObject?.contentOuter?.imageStatus?<img    className="CourseSideStickImgTw" src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer" }}/>:""}
</div>
<h2 className="coursePageHeaderFont" style={{color:coursePageObject?.contentOuter?.textColor?.color }}>Sub Course  1</h2>
  <div  style={{display:"flex",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",gap:"10px"}}> 
                       <div className="" style={{padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}> 
                         <ListChecks strokeWidth={1}  size={20}    color={coursePageObject?.contentOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.contentOuter?.subTextColor?.color}}> 5  Milestones</div>
                           </div><div className="" style={{padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}> 
                         <BellElectric strokeWidth={1}  size={20}    color={coursePageObject?.contentOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.contentOuter?.subTextColor?.color}}> 5  Sections</div>
                           </div><div className="" style={{padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}> 
                         <ImagePlay strokeWidth={1}  size={20}    color={coursePageObject?.contentOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.contentOuter?.subTextColor?.color}}> 5  Chapters</div>
                           </div>
                   </div>
           </div>
<div className="themeCoursePage courseContentTitleFontTwoCoursePage coursePageTitleFont"style={{marginBottom:"20px",
  color:coursePageObject?.contentOuter?.subTextColor?.color
}}>Course Content</div>
<HorizontalScroller coursePageObject={coursePageObject} items={[{menuOrder:1,active:true},{menuOrder:2},{menuOrder:3},{menuOrder:4}]} />

<div className=" " style={{marginTop:"150px"}}>


<CourseContentCard coursePageObject={coursePageObject} />




</div>

<div className="contentsRemainingButtonOuter">
  <div className="themeCoursePage contentsRemainingButtonOuter"  style={{fontSize:"16px",
  fontWeight:"700",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:`${coursePageObject?.moreSectionsBtn?.bgColor?.color}`,
    border:` ${coursePageObject?.moreSectionsBtn?.border?.borderWidth?.value+coursePageObject?.moreSectionsBtn?.border?.borderWidth?.resolution} ${coursePageObject?.moreSectionsBtn?.border?.borderType}  ${coursePageObject?.moreSectionsBtn?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.topLeft?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.topRight?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomLeft?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomRight?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomRight?.resolution}`,
}}>
  <Plus  strokeWidth={3}   absoluteStrokeWidth  size={25}  color={coursePageObject?.moreSectionsBtn?.textColor?.color}/> <div className="themeCoursePage"  style={{margin:"0px"}}> 
    <div  className="themeCoursePage coursePageButtonFont" style={{marginTop:"-5px", color:coursePageObject?.moreSectionsBtn?.textColor?.color}}>  6 More Sections</div></div></div>

  </div>
  </div></>)
}
export default CourseContentCardHolder;